import { Button } from '@/components/ui/button'
import { X } from 'lucide-react'

interface BulkActionsBarProps {
  count: number
  onClear: () => void
  children: React.ReactNode
}

/**
 * Floating bottom bar that appears when one or more table rows are selected.
 * Shows "N selected" on the left, context-specific action buttons in the middle,
 * and a clear-selection control on the right. Shared by the extraction tables
 * and the bids table.
 */
export function BulkActionsBar({ count, onClear, children }: BulkActionsBarProps) {
  if (count === 0) return null

  return (
    <div
      className="fixed bottom-6 inset-x-0 z-50 flex justify-center pointer-events-none"
      role="region"
      aria-label="Bulk actions"
    >
      <div className="pointer-events-auto animate-fade-in flex items-center gap-2 bg-foreground text-background rounded-xl shadow-lg px-3 py-2">
        <span className="text-sm font-medium pl-1 pr-2 border-r border-background/20">
          {count} selected
        </span>

        <div className="flex items-center gap-1">{children}</div>

        <Button
          size="icon"
          variant="ghost"
          className="h-7 w-7 text-background hover:bg-background/15 hover:text-background"
          onClick={onClear}
          aria-label="Clear selection"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
